/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Cities from './Cities/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Details/Office/City",
  onChange
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.postal_address.city',
})
let editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressCityChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'employee.provider.employee_resource.employment_contract.organization.postal_address.city',
})
  return (<React.Fragment
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 marginTop={dtSpaceM}
 text="City"
/>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaInput
{...childProps}
  viewPath={`${viewPath}/TysiaInput`}
 disabled={true}
 marginTop={0}
 data="edit_professional.employee.provider.employee_resource.employment_contract.organization.postal_address.city"
 value={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressCityValueData}
 onChange={editProfessionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationPostalAddressCityChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Cities
{...childProps}
  viewPath={`${viewPath}/Cities`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}